import {
  DEFAULT_PRIME_PITCH_BENEFIT_COLOUR,
  PrimeTrialPromoApiResponse,
  PrimeTrialPromoModalData
} from './types';

export default function mapPrimeTrialPromoResponseToModalData(
  response: PrimeTrialPromoApiResponse
): PrimeTrialPromoModalData {
  return {
    isRenew: response.isRenew,
    heroVideoUrl: response.videoUrl,
    brandLogoSrc: '/static/images/logo_m.svg',
    primeLogoSrc: response.primeLogoUrl,
    priceImageSrc: response.priceImageUrl,
    renewTitle: response.renewTitle ?? '',
    renewSubtitle: response.renewSubtitle ?? '',
    trialPrimaryText: response.contextualText?.primaryText ?? '',
    trialContinText: response.contextualText?.secondaryText ?? '',
    tagLine: response.tagLine ?? '',
    primeTagUrl: response.primeTagUrl ?? null,
    benefitsHeader: response.benefitsHeader ?? '',
    primaryCtaLabel: response.ctaDetails.ctaPriceText,
    benefits: response.benefits.map((benefit) => ({
      logoSrc: benefit.logoUrl,
      label: benefit.subTitle,
      count: benefit.title,
      colour: benefit.colour || DEFAULT_PRIME_PITCH_BENEFIT_COLOUR
    }))
  };
}
